import React, { useState, useEffect, useRef } from 'react';
import { FileUpload } from "primereact/fileupload";
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import Loader from "../Shared/Loader/Loader";
import APIConstant from "../../utils/pathConstants";
import api from "../../utils/apiClient";
import CommonConfig from '../../utils/constant';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import Toast from '../Shared/Toast/Toast';
import { RadioButton } from 'primereact/radiobutton';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { useCatchResponse } from '../../utils/useCatchResponse';
import userImage from '../../assets/images/UserImage.png';
import { apiBase } from '../../utils/config';
import moment from 'moment';

const TakeAttendance = () => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [classList, setClassList] = useState([]);
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [childRows, setChildRows] = useState(10);
    const [childFirst, setChildFirst] = useState(0);
    const [selectedDate, setSelectedDate] = useState(new Date);
    const [attendanceList, setAttendanceList] = useState([]);
    const attendanceOptions = [
        { label: "P", value: "P", color: "green" },
        { label: "A", value: "A", color: "red" },
        { label: "L", value: "L", color: "yellow" },
    ];
    const [classTime, setClassTime] = useState('');
    const [selectedSubjectId, setSelectedSubjectId] = useState('');
    const [isStudentView, setIsStudentView] = useState(false);
    const [markAllPresent, setMarkAllPresent] = useState(false);
    const [isGuestLecture, setIsGuestLecture] = useState(false);
    const [guestTeacherName, setGuestTeacherName] = useState('');
    const [originalAttendanceList, setOriginalAttendanceList] = useState([]);
    const [pageAccess, setPageAccess] = useState({});
    const [modeType, setModeType] = useState('');
    const [financialYear, setFinancialYear] = useState('');
    const [academicStartDate, setAcademicStartDate] = useState(null);
    const [academicEndDate, setAcademicEndDate] = useState(null);
    const fileUploadRef = useRef(null);
    const [isUploadVisible, setIsUploadVisible] = useState(false);
    const [dayStatus, setDayStatus] = useState(null);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        getFinancialYearData(loginData);
        const accessData = CommonConfig.getUserAccess('Take Attendance');
        setPageAccess(accessData);
    }, []);

    const getFinancialYearData = async (loginData) => {
        const years = await CommonConfig.getFinancialYears(CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : loginData?.CreatedBy);
        const currentYear = CommonConfig.getCurrentFinancialYear(years);
        const selectedAcYear = CommonConfig.getCookie('selectedAcademicYear');
        setFinancialYear(selectedAcYear ?? currentYear?.value);
        await GetConfigurationData(CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : loginData?.CreatedBy, years, selectedAcYear ?? currentYear?.value);
        await GetClassList(CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : loginData?.CreatedBy, loginData?._id, selectedDate, selectedAcYear ?? currentYear?.value);
    }

    const GetConfigurationData = async (id, academicYearList, selectedYear) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.GetGeneralConfigurationDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    if (res?.data?.IsAcademicYearApply) {
                        const academicCalendar = academicYearList || [];

                        if (!academicCalendar.length) {
                            setAcademicStartDate(null);
                            setAcademicEndDate(null);
                            return;
                        }

                        const validRanges = academicCalendar.filter(
                            item => item?.StartDate && item.EndDate && item?._id === selectedYear
                        );

                        if (!validRanges.length) {
                            setAcademicStartDate(null);
                            setAcademicEndDate(null);
                            return;
                        }

                        const sortedCalendar = [...validRanges].sort(
                            (a, b) =>
                                new Date(a?.StartDate) - new Date(b?.StartDate)
                        );

                        const start = new Date(sortedCalendar[0]?.StartDate);
                        const end = new Date(sortedCalendar[0]?.EndDate);

                        setAcademicStartDate(start);
                        setAcademicEndDate(end);
                    }
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const formatDateToYMD = (dateObj) => {
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    };

    const GetClassList = async (schoolId, id, date, financialId) => {
        try {
            let formattedDate = formatDateToYMD(date);
            let data = {
                SchoolId: schoolId,
                UserId: id,
                SelectedDate: formattedDate,
                FinancialYearId: financialId
            }
            Loader.show();
            await api.post(APIConstant.path.GetAttendanceClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(res.data);
                    setDayStatus(res.dayStatus || null);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetAttendanceList = async (classId, subjectId, classTime) => {
        try {
            let formattedDate = formatDateToYMD(selectedDate);
            let data = {
                UserID: securityUserID,
                ClassId: classId,
                ClassTime: classTime,
                SubjectId: subjectId,
                SelectedDate: formattedDate,
                Type: 'Today',
                FinancialYearId: financialYear
            }
            Loader.show();
            await api.post(APIConstant.path.GetAttendanceListByClass, data).then(async response => {
                let res = response;
                if (res.success) {
                    const list = res?.data?.sort((a, b) => a?.RollNo - b?.RollNo) || [];
                    setAttendanceList(list);
                    const g = list.find(r => r?.IsGuestLecture);
                    setIsGuestLecture(!!g);
                    setGuestTeacherName(g?.GuestTeacherName || '');
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const onChildPageChange = (e) => {
        setChildFirst(e.first);
        setChildRows(e.rows);
    };

    const handleEdit = (rowIndex, value) => {
        setAttendanceList((prevItems) => {
            const updatedList = prevItems.map((item, index) =>
                index === rowIndex
                    ? { ...item, AttendanceType: value }
                    : { ...item }
            );
            const allPresent = updatedList.every(
                (item) => item?.AttendanceType === 'P'
            );
            setMarkAllPresent(allPresent);

            return updatedList;
        });
    };

    const handleMarkAllPresent = (checked) => {
        setMarkAllPresent(checked);
        if (checked) {
            setOriginalAttendanceList([...attendanceList]);
            const updatedList = attendanceList.map((student) => ({
                ...student,
                AttendanceType: 'P',
            }));
            setAttendanceList(updatedList);
        } else {
            setAttendanceList(originalAttendanceList);
        }
    };

    const attendanceBodyTemplate = (rows, props) => {
        return (
            <div className="p-d-flex p-ai-center" style={{ gap: "5px" }}>
                {attendanceOptions.map((option, index) => (
                    <div key={index} className="p-d-flex p-ai-center" style={{ gap: "5px" }}>
                        <RadioButton
                            inputId={`attendance-${props.rowIndex}-${option.value}`}
                            name={`attendance-${props.rowIndex}`}
                            value={option.value}
                            disabled={modeType === 'View' ? true : false}
                            checked={rows?.AttendanceType === option.value}
                            onChange={() => handleEdit(props.rowIndex, option.value)}
                        />
                        <label
                            htmlFor={`attendance-${props.rowIndex}-${option.value}`}
                            style={{
                                color: option.color,
                                fontWeight: "bold",
                                cursor: "pointer",
                            }}
                        >
                            {option.label}
                        </label>
                    </div>
                ))}
            </div>
        );
    };

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className="p-d-flex p-ai-center" style={{ gap: "5px" }}>
                    {(rows?.IsTake && pageAccess?.AddAccess) &&
                        <Button icon="pi pi-check-square" tooltip="Take" tooltipOptions={{ position: 'top' }} className="e-sction-btn p-my-0 p-m-0" onClick={() => {
                            GetAttendanceList(rows?.ClassId, rows?.SubjectId ?? '', rows?.ClassTime ?? '');
                            setClassTime(rows?.ClassTime ?? '');
                            setSelectedSubjectId(rows?.SubjectId ?? '');
                            setIsStudentView(true)
                            setModeType('New');
                        }} />}
                    {(!rows?.IsTake && pageAccess?.EditAccess) &&
                        <Button icon="pi pi-pencil" tooltip="Edit" tooltipOptions={{ position: 'top' }} className="e-sction-btn p-my-0 p-m-0" onClick={() => {
                            GetAttendanceList(rows?.ClassId ?? '', rows?.SubjectId ?? '', rows?.ClassTime ?? '');
                            setClassTime(rows?.ClassTime ?? '');
                            setSelectedSubjectId(rows?.SubjectId ?? '');
                            setIsStudentView(true)
                            setModeType('Edit');
                        }} />}
                    <Button icon="pi pi-eye" tooltip="View" tooltipOptions={{ position: 'top' }} className="e-sction-btn p-my-0 p-m-0" onClick={() => {
                        GetAttendanceList(rows?.ClassId ?? '', rows?.SubjectId ?? '', rows?.ClassTime ?? '');
                        setClassTime(rows?.ClassTime ?? '');
                        setSelectedSubjectId(rows?.SubjectId ?? '');
                        setIsStudentView(true)
                        setModeType('View');
                    }} />
                </div>
            </React.Fragment>

        );
    };

    const saveAttendance = async () => {
        try {
            if (isGuestLecture && CommonConfig.isEmpty(guestTeacherName)) {
                Toast.error({ message: 'Please enter the Guest Teacher name' });
                return;
            }
            const loginData = CommonConfig.loginData();
            const scopeUserId = CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : (loginData?.CreatedBy || loginData?._id);
            const requestData = attendanceList?.map(row => ({
                id: row?.id,
                ClassId: row?.ClassId ?? '',
                StudentId: row?.StudentId ?? '',
                SubjectId: selectedSubjectId ?? '',
                ClassTime: classTime ?? '',
                TakenBy: securityUserID,
                AttendanceType: row?.AttendanceType ?? '',
                AttendanceDate: moment(selectedDate).format("YYYY/MM/DD"),
                FinancialYear: financialYear,
                IsGuestLecture: isGuestLecture,
                GuestTeacherName: isGuestLecture ? (guestTeacherName || '') : '',
                CreatedBy: securityUserID
            }));
            const response = await api.post(APIConstant.path.AddAttendanceDetail, requestData);
            if (response.success) {
                Toast.success({ message: response.message });
                setIsStudentView(false);
                setAttendanceList([]);
                setClassTime('');
                setMarkAllPresent(false);
                GetClassList(scopeUserId, securityUserID, selectedDate, financialYear);
            } else {
                setIsStudentView(false);
                setAttendanceList([]);
                setClassTime('');
                setMarkAllPresent(false);
                GetClassList(scopeUserId, securityUserID, selectedDate, financialYear);
                Toast.error({ message: "Failed to save timetable" });
            }
        } catch (error) {
            setIsStudentView(false);
            setClassTime('');
            setMarkAllPresent(false);
            setAttendanceList([]);
            catchResponse();
        }
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={() => {
                    setIsStudentView(false);
                    setClassTime('');
                    setAttendanceList([]);
                }}
            />
            <Button
                label="Save"
                className="p-m-0 btn-text-action-primary p-m-1"
                onClick={() => saveAttendance()}
                tooltip="Save Changes"
                tooltipOptions={{ position: "top" }}
            />
        </div>
    );

    const studentNameWithImageTemplate = (rowData) => {
        const imageUrl = rowData?.ProfilePic
            ? `${apiBase}/UserProfilePic/${rowData?.ProfilePic}`
            : userImage;

        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img
                    src={imageUrl}
                    alt={rowData.StudentName}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = userImage;
                    }}
                    style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                    }}
                />
            </div>
        );
    };

    const handleDownloadSampleFile = async () => {
        try {
            Loader.show();
            const loginData = CommonConfig.loginData();
            const scopeUserId = CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : loginData?.CreatedBy;
            const res = await api.post(APIConstant.path.GenerateAttendanceSample, {
                accountType: loginData?.AccountType,
                userType: loginData?.UserType,
                userId: scopeUserId,
            });
            if (res.success && res?.sampleFileUrl) {
                const downloadUrl = `${apiBase}${res.sampleFileUrl}`;
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", downloadUrl.split('/').pop());
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                Loader.hide();
            } else {
                Loader.hide();
                Toast.error({ message: res?.message || 'Failed to download sample file' });
            }
        } catch (err) {
            Loader.hide();
            Toast.error({ message: err?.message || 'Failed to download sample file' });
            catchResponse(err);
        }
    };

    const handleUploadVisible = () => {
        setIsUploadVisible(false);
    };

    const headerTemplate = (options) => {
        const { className, chooseButton, uploadButton, cancelButton } = options;
        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {uploadButton}
                {cancelButton}
            </div>
        );
    };

    const itemTemplate = (file, props) => {
        return (
            <div className="">
                <div className="p-d-flex p-ai-baseline p-jc-between">
                    <div className="flex flex-column text-left ml-3">
                        <p> {file.name} </p>
                        <small>{new Date().toLocaleDateString()}</small>
                    </div>
                </div>
                <Tag value={props.formatSize} severity="warning" className="e-uplod-box" />
                <div className='p-d-flex p-ai-center p-jc-center'>
                    <Button type="button" icon="pi pi-times" className="p-d-flex p-ai-center p-jc-center p-button-outlined p-button-rounded p-button-danger ml-auto p-m-0" onClick={() => onTemplateRemove(file, props.onRemove)} />
                </div>
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column">
                <i className="pi pi-image mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    Drag and Drop Image Here
                </span>
            </div>
        );
    };

    const onTemplateUpload = async (e) => {
        const uploadedFile = e.files[0];
        if (!uploadedFile) return;

        try {
            Loader.show();
            const loginData = CommonConfig.loginData();
            const scopeUserId = CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : loginData?.CreatedBy;
            const formData = new FormData();
            formData.append("file", uploadedFile);
            formData.append("filename", uploadedFile?.name);
            formData.append("accountType", loginData?.AccountType);
            formData.append("userType", loginData?.UserType);
            formData.append("userId", scopeUserId);
            formData.append("takenBy", loginData?._id);
            formData.append("financialYearId", financialYear);
            await api.post(APIConstant.path.ImportAttendance, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(async (response) => {
                    let res = response;
                    if (res.success) {
                        Loader.hide();
                        if (res?.skippedFileUrl) {
                            var downloadUrl = `${apiBase}${res?.skippedFileUrl}`;
                            const link = document.createElement("a");
                            link.href = downloadUrl;
                            link.setAttribute("download", downloadUrl.split('/').pop());
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }
                        handleUploadVisible();
                        Toast.success({ message: res?.message });
                        GetClassList(scopeUserId, securityUserID, selectedDate, financialYear);
                    } else {
                        Loader.hide();
                        if (res?.skippedFileUrl) {
                            var downloadcatchUrl = `${apiBase}${res?.skippedFileUrl}`;
                            const link = document.createElement("a");
                            link.href = downloadcatchUrl;
                            link.setAttribute("download", downloadcatchUrl.split('/').pop());
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }
                        Toast.error({ message: res.message });
                    }
                })
                .catch((err) => {
                    Toast.error({ message: err?.message });
                    Loader.hide();
                });
        } catch (error) {
            Loader.hide();
            const errorMessage = error.response?.data?.message || "File upload failed.";
            Toast.error({ message: errorMessage });
            catchResponse(error);
        }
    };

    const onTemplateRemove = (file, callback) => {
        callback();
    };

    const chooseOptions = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'p-d-flex p-ai-center p-jc-center p-button-rounded p-button-outlined p-m-0' };
    const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: 'p-d-flex p-ai-center p-jc-center p-button-success p-button-rounded p-button-outlined p-m-0' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'p-d-flex p-ai-center p-jc-center p-button-danger p-button-rounded p-button-outlined p-m-0' };

    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-window-minimize"></i>
                    <h2>Take Attendance</h2>
                </div>
                <div className="p-grid p-align-center">
                    <label htmlFor="attendanceDate">Attendance Date </label>
                    <div className='searchbar-area'>
                        <Calendar
                            className='p-w-100 p-mt-0'
                            id="attendanceDate"
                            value={selectedDate}
                            minDate={academicStartDate}
                            maxDate={academicEndDate}
                            hourFormat="12"
                            dateFormat="dd/mm/yy"
                            onChange={(e) => {
                                setSelectedDate(e.value);
                                const loginData = CommonConfig.loginData();
                                const scopeUserId = CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : (loginData?.CreatedBy || loginData?._id);
                                GetClassList(scopeUserId, securityUserID, e.value, financialYear)
                            }
                            }
                        />
                    </div>
                    {pageAccess?.AddAccess &&
                        <Button icon="pi pi-download" onClick={handleDownloadSampleFile} className="e-h-btn" />}
                    {pageAccess?.AddAccess &&
                        <Button icon="pi pi-upload" className="e-h-btn p-ml-2" onClick={() => setIsUploadVisible(true)} />}
                </div>
            </div>
            {dayStatus?.IsSpecialDay && (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.6rem',
                    margin: '0.5rem 0 0.75rem',
                    padding: '0.75rem 1rem',
                    borderRadius: '0.5rem',
                    border: `1px solid ${dayStatus.Type === 'Holiday' ? '#f5c2c7' : '#b6d4fe'}`,
                    background: dayStatus.Type === 'Holiday' ? '#fff5f5' : '#eff6ff',
                    color: dayStatus.Type === 'Holiday' ? '#b02a37' : '#084298'
                }}>
                    <i className={dayStatus.Type === 'Holiday' ? 'pi pi-info-circle' : 'pi pi-calendar'} style={{ fontSize: '1.1rem' }}></i>
                    <span>
                        {dayStatus.Type === 'Holiday'
                            ? <>This day is a <b>Holiday</b>{dayStatus.Name ? <> — {dayStatus.Name}</> : ''}. Attendance cannot be taken on holidays.</>
                            : <>This day has an <b>Event</b>{dayStatus.Name ? <> — {dayStatus.Name}</> : ''}. You can still take attendance.</>}
                        {dayStatus.Remark ? <span style={{ opacity: 0.85 }}> ({dayStatus.Remark})</span> : null}
                    </span>
                </div>
            )}
            {dayStatus?.Type === 'Holiday' ? (
                <div style={{ textAlign: 'center', color: '#b02a37', padding: '2.5rem 1rem', fontWeight: 500 }}>
                    Attendance cannot be taken on a holiday.
                </div>
            ) : (
                <div>
                    <DataTable
                        value={classList}
                        paginator
                        rows={rows}
                        first={first}
                        filterDisplay="menu"
                        responsiveLayout="scroll"
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                        onPage={onPageChange}
                        className='custom-table p-mt-3'
                        scrollHeight='calc(100vh - 175px)'
                        size='small'
                    >
                        <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." />
                        <Column
                            field="ClassName"
                            header="Class Name"
                        />
                        <Column
                            field='ClassTime'
                            header='Class Time'
                        />
                        <Column
                            field="SubjectName"
                            header="Subject Name"
                        />
                        <Column
                            field='AttendanceData'
                            header='Total Attendance'
                        />
                        <Column
                            header="Action" headerClassName='e-template-action' bodyClassName='e-template-action'
                            headerStyle={{ width: '100%' }}
                            body={actionBodyTemplate}
                        />
                    </DataTable>
                </div>
            )}
            <Dialog
                header={attendanceList ? `${attendanceList[0]?.Classname} ${attendanceList[0]?.SubjectName ? (attendanceList[0]?.SubjectName - classTime) : ''}` : ''}
                visible={isStudentView}
                onHide={() => {
                    setIsStudentView(false);
                    setClassTime('');
                    setAttendanceList([]);
                }}
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
            >
                <div className="p-ai-center">
                    <div className="p-d-flex p-ai-center p-flex-wrap p-mb-2" style={{ gap: '10px' }}>
                        <Checkbox
                            inputId="guest-lecture"
                            checked={isGuestLecture}
                            disabled={modeType === 'View'}
                            onChange={(e) => { setIsGuestLecture(e.checked); if (!e.checked) setGuestTeacherName(''); }}
                        />
                        <label htmlFor="guest-lecture">Guest Lecture</label>
                        {isGuestLecture && (
                            <InputText
                                value={guestTeacherName}
                                disabled={modeType === 'View'}
                                onChange={(e) => setGuestTeacherName(e.target.value)}
                                placeholder="Guest Teacher Name *"
                                maxLength={80}
                                style={{ minWidth: '220px' }}
                            />
                        )}
                    </div>
                    <DataTable
                        value={attendanceList}
                        paginator
                        rows={childRows}
                        first={childFirst}
                        filterDisplay="menu"
                        responsiveLayout="scroll"
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                        onPage={onChildPageChange}
                        className='custom-table'
                        scrollHeight='calc(100vh - 280px)'
                        size='small'
                    >
                        <Column
                            field="RollNo"
                            header="Roll No"
                        />
                        <Column header="Student Pic" body={studentNameWithImageTemplate} />
                        <Column
                            field="StudentName"
                            header="Student Name"
                        />
                        <Column
                            field="Attendance"
                            header={
                                <div className="p-d-flex p-ai-center">
                                    <Checkbox
                                        inputId="mark-all-present"
                                        checked={markAllPresent}
                                        disabled={modeType === 'View' ? true : false}
                                        onChange={(e) => handleMarkAllPresent(e.checked)}
                                        tooltip="Mark all Present"
                                    />
                                    <label htmlFor="mark-all-present" style={{ marginLeft: '5px' }}>Attendance</label>
                                </div>
                            }
                            body={attendanceBodyTemplate}
                        />
                    </DataTable>
                </div>
            </Dialog>
            <Dialog
                visible={isUploadVisible}
                onHide={handleUploadVisible}
                header="Upload Excel"
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '500px', minHeight: '480px', maxHeight: '480px', }}
            >
                <div>
                    <div className='p-d-fle p-ai-center p-jc-between p-w-100'>
                        <div>
                            <Tooltip className='p-m-0' target=".custom-choose-btn" content="Choose" position="bottom" />
                        </div>
                        <div>
                            <Tooltip className='p-m-0' target=".custom-upload-btn" content="Upload" position="bottom" />
                        </div>
                        <div>
                            <Tooltip className='p-m-0' target=".custom-cancel-btn" content="Clear" position="bottom" />
                        </div>
                        <FileUpload ref={fileUploadRef} name="file" accept=".xlsx" multiple={false} customUpload={true} uploadHandler={onTemplateUpload} headerTemplate={headerTemplate} itemTemplate={itemTemplate} emptyTemplate={emptyTemplate} chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} />
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default TakeAttendance;
